import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <p className="contact-subtitle">
        We're here to help. Reach out to us through any of the following channels.
      </p>
      <div className="contact-details">
        <div className="contact-item">
          <img src="/Icons/Icon_Email.png" alt="Email Icon" className="contact-icon" />
          <a href="mailto:info@galaxyadvisors.com" className="contact-link">info@galaxyadvisors.com</a>
        </div>
        <div className="contact-item">
          <img src="/Icons/Icon_Phone.png" alt="Phone Icon" className="contact-icon" />
          <a href="tel:+41628228650" className="contact-link">+41 62 822 86 50</a>
        </div>
        <div className="contact-item">
          <img src="/Icons/Icon_Location.png" alt="Location Icon" className="contact-icon" />
          <p className="contact-address">Laurenzenvorstadt 69, CH-5000 Aarau - Switzerland</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
